import React, { FC } from "react";
import { PerfumeResponse } from "../../../types/types";
import "./OrderItem.css";

type PropsType = {
  perfume: PerfumeResponse;
  quantity?: number;
};

const OrderItem: FC<PropsType> = ({ perfume, quantity }) => {
  const qty           = quantity ?? 1;
  const isDistributor = localStorage.getItem("role") === "3";

  // ── Pick correct price & discount based on role ──
  const basePrice = perfume.actualPrice ?? perfume.price;
  const unitPrice = isDistributor
    ? (perfume.distributorPrice ?? perfume.price)
    : basePrice - (basePrice * (perfume.discount ?? 0) / 100);

  const discountPct = isDistributor
    ? (perfume.distributorDiscount ?? 0)
    : (perfume.discount ?? 0);

  const lineTotal = unitPrice * qty;
  const lineMRP   = basePrice * qty;

  return (
    <div className="oi-row">
      <div className="oi-img-wrap">
        <img
          src={perfume.filename}
          alt={perfume.perfumeTitle}
          className="oi-img"
        />
      </div>

      <div className="oi-info">
        <span className="oi-title">{perfume.perfumeTitle}</span>
        <span className="oi-brand">{perfume.brand}</span>
        <div className="oi-meta-row">
          <span className="oi-qty">Qty: {qty}</span>
          {discountPct > 0 && (
            <span className="oi-discount-badge">{discountPct}% OFF</span>
          )}
        </div>
        {isDistributor && (
          <span className="oi-dist-label">Distributor Price</span>
        )}
      </div>

      <div className="oi-price-col">
        <span className="oi-total">₹{lineTotal.toFixed(0)}</span>
        {discountPct > 0 && (
          <span className="oi-unit-old">₹{lineMRP.toFixed(0)}</span>
        )}
      </div>
    </div>
  );
};

export default OrderItem;